<script>
// @group Sliders
// Time slider mixin
export default {
  name: "TimeSliderMixin",
  methods: {
    // @vuese
    // Return time in format HH:MM:SS.SS
    // @arg seconds - count of seconds
    getTime(seconds) {
      const ms = Math.floor((seconds % 1) * 1000).toString().padStart(3, '0');
      const ss = Math.floor(seconds % 60)
        .toString()
        .padStart(2, "0");
      const mm = (Math.floor(seconds / 60) % 60).toString().padStart(2, "0");
      const hh = Math.floor(seconds / 3600)
        .toString()
        .padStart(2, "0");

      return [hh, mm, ss].join(":") + '.' + ms;
    }
  }
};
</script>
